import React from 'react';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function GuaranteeClose() {
  return <footer className="w-full bg-ink" data-id="element-72" data-mp="28umkqpt36qho">
      <div className="mx-auto max-w-content px-5 py-10 sm:py-16 lg:py-24" data-id="element-73" data-mp="28vo73qfjyzep">
        <div className="mx-auto max-w-3xl text-center" data-id="element-74" data-mp="2mm02pzbcjgal">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-gold/40 text-gold" data-id="element-75" data-mp="2hurrcxqghkus">
            <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-76" data-mp="2wimi48kwlf58" />
          </span>

          <h2 className="mt-6 font-display text-3xl text-cream sm:text-[42px] sm:leading-tight" data-id="element-77" data-mp="2rkuisthxiqr0">
            Garantía incondicional de satisfacción por 7 días
          </h2>

          <p className="mt-5 text-base leading-relaxed text-muted" data-id="element-78" data-mp="30kzpf1fatl44">
            Prueba el método. Examina los tomos, utiliza los guiones y revisa los
            checklists. Si en los primeros 7 días sientes que este material no eleva la
            calidad y la seguridad de tus sesiones, escríbenos y te devolveremos el 100%
            de tu dinero. Sin preguntas.
          </p>

          <p className="mt-7 font-display text-2xl text-gold sm:mt-10 sm:text-3xl" data-id="element-79" data-mp="3pxhyi5u4fgs2">
            Da el paso: profesionaliza tus regresiones con orden, guía y discernimiento.
          </p>

          <a href="https://hipnosis-regresiva.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="group mt-6 inline-flex items-center gap-2.5 rounded-full bg-gold px-6 py-4 font-sans text-[14px] font-semibold leading-tight text-[#1B0F00] transition-[transform,background-color] duration-150 ease-out hover:bg-[#E8C480] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold active:scale-[0.98] sm:mt-8 sm:gap-3 sm:px-8 sm:text-[15px]" data-id="element-80" data-mp="3r37oqoej3oq">
            Comprar y descargar ahora por $ 19
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-81" data-mp="2ob0oplhun21w" />
          </a>

          <p className="mt-5 text-[13px] text-muted" data-id="element-82" data-mp="2tbg22d24s9jv">
            Pago 100% seguro · Entrega inmediata · Garantía de 7 días
          </p>
        </div>

        <p className="mt-10 border-t border-line pt-6 text-center text-[12px] text-muted sm:mt-16 sm:pt-8" data-id="element-83" data-mp="2gamar42snzaf">
          Memorias del Alma™ · Material formativo para terapeutas y facilitadores. No
          sustituye tratamiento médico ni psicológico.
        </p>
      </div>
    </footer>;
}